import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

// interface
import { IFavouriteListModule, IModalProps, ILinkProps, IResizeOption, IFavoriteProps } from '../../../interfaces/interfaces';

// module, source
import Header from '../../elements/Header/Header';
import Link from '../../elements/Link/Link';
import TileWrapper from '../../elements/TileWrapper/TileWrapper';
import { ModalContextConsumer } from '../../../contexts/modalContext';
import randomId from '../../../utils/randomId';
import UserTileContext from '../../../contexts/userTilesContext';
import { saveConfiguration } from '../../../utils/data';
import keyboardTriggerBasic from '../../../utils/keyboard-trigger';

function FavouriteListModule(props: IFavouriteListModule & ILinkProps): JSX.Element {
  const { headline, tileId, favorites, hideMenu, isEditable = true, resizeOptions, tileLayout } = props;
  const { t } = useTranslation();
  const userTiles = useContext(UserTileContext);
  const allTiles = userTiles.tiles;

  const tW = tileLayout?.w || 2;
  const tH = tileLayout?.h || 1;

  let maxDisplayedLinks = 4;

  if (tW === 2 && tH === 1) {
    maxDisplayedLinks = 2;
  } else if (tW === 2 && tH === 2) {
    maxDisplayedLinks = 7;
  } 

  const openFavouriteListModal = (openModal: (modal: IModalProps) => void) => {
    openModal({
      type: 'favourite',
      key: 'favourite',
      list: favorites,
      message: '',
      onAbort: () => {
        //---
      },
      onConfirm: () => {
        //---
      },
    });
  };
  const openFavouriteListModalEdit = (openModal: (modal: IModalProps) => void) => {
    openModal({
      type: 'favouriteEdit',
      key: 'favouriteEdit',
      list: favorites,
      message: '',
      onAbort: () => {
        //---
      },
      onConfirm: () => {
        //---
      },
    });
  };
  const availableResizeOptions = () => {
    const [myTile] = allTiles.filter((ti) => ti.id === tileId);
    if (myTile) {
      return resizeOptions?.filter((ro) => {
        return ro.w !== myTile.layout.w || ro.h !== myTile.layout.h;
      });
    }
    return [];
  };

  const resizeTile = (size: IResizeOption) => {
    const updatedSet = allTiles.map((ti) => {
      if (ti.id === tileId) {
        return { ...ti, layout: { ...ti.layout, w: size.w, h: size.h } };
      }
      return { ...ti, layout: { ...ti.layout, isResizable: false } };
    });
    userTiles.setTiles(updatedSet);
    saveConfiguration(updatedSet, userTiles.settings).catch(() => {
      // TODO: better error messages
    });
  };

  return (
    <>
      <ModalContextConsumer>
        {({ openModal }) => (
          <div className="tile-body">
            {headline ? (
              <Header
                headline={headline}
                tileId={tileId}
                hideMenu={hideMenu}
                onToggleEditing={() => {
                  openFavouriteListModalEdit(openModal);
                }}
                isEditable
                resizeOptions={availableResizeOptions()}
                onResize={resizeTile}
              />
            ) : (
              ''
            )}
            <TileWrapper className="tile-padding" clickable={false}>
              <ul className="tile-linklist">
                {favorites?.sort((a, b) => ((a as IFavoriteProps).sortIndex || 0) - ((b as IFavoriteProps).sortIndex || 0)).slice(0, maxDisplayedLinks).map((link) => (
                  <li key={randomId('favourite-list')}>
                    <Link
                      linkHref={link.linkHref}
                      linkText={link.linkText}
                      linkClass={`link link-item ic-arrowRight ${link.linkClass}`}
                      linkTextClass="link-text"
                    />
                  </li>
                ))} 

                <Link
                  onClick={() => {
                    openFavouriteListModal(openModal);
                  }}
                  onKeyDown={(e) => {
                    keyboardTriggerBasic(e, () => {
                      openFavouriteListModal(openModal);
                    });
                  }}
                  linkText={t('cockpit.favourite.openModal')}
                  linkClass="multiple-link tile-link link ic-arrowRight"
                  linkTextClass="link-text"
                />
              </ul>
            </TileWrapper>
          </div>
        )}
      </ModalContextConsumer>
    </>
  );
}
export default FavouriteListModule;
